export const shortHash = (h, chars = 6) =>
  h ? `${h.slice(0, chars + 2)}…${h.slice(-chars)}` : "";

export const fmtNum = (n, opts = {}) => {
  if (n === null || n === undefined || n === "" || isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-US", { maximumFractionDigits: 2, ...opts });
};

export const fmtUsd = (n, digits) => {
  if (n === null || n === undefined || n === "" || isNaN(Number(n))) return "—";
  const v = Number(n);
  const d = digits ?? (v < 1 ? 6 : 2);
  const min = Math.min(v >= 1 ? 2 : 0, d);
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: min, maximumFractionDigits: d })}`;
};

export const fmtCompact = (n) => {
  if (n === null || n === undefined || isNaN(Number(n))) return "—";
  return Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 2 }).format(Number(n));
};

export const weiToEth = (wei) => (wei ? Number(wei) / 1e18 : 0);

export const fmtEth = (wei, digits = 6) => {
  const v = weiToEth(wei);
  if (v === 0) return "0 ETH";
  return `${v.toLocaleString("en-US", { maximumFractionDigits: digits })} ETH`;
};

export const fmtTokenAmount = (value, decimals) => {
  if (value === null || value === undefined) return "—";
  try {
    const d = Number(decimals ?? 18);
    const v = Number(value) / 10 ** d;
    if (v === 0) return "0";
    if (v < 0.0001) return v.toExponential(2);
    return v.toLocaleString("en-US", { maximumFractionDigits: 4 });
  } catch {
    return String(value);
  }
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 0) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", timeZoneName: "short",
  });
};

export const txAction = (tx) => {
  const types = tx.transaction_types || [];
  const method = tx.method;
  if (types.includes("contract_creation")) return "Contract Deploy";
  if (method && /swap|multicall|exact/i.test(method)) return "Swap";
  if (types.includes("token_transfer")) return "Token Transfer";
  if (types.includes("coin_transfer")) return "ETH Transfer";
  if (types.includes("contract_call")) return method ? `Call: ${method}` : "Contract Call";
  return method || "Transaction";
};
